import { TowAttempt } from '@models/tow-attempt.model';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export const adapter: EntityAdapter<TowAttempt> = createEntityAdapter<TowAttempt>({
    selectId: towAttempt => towAttempt.id
});

export interface State extends EntityState<TowAttempt> {
    loading: boolean;
    error?: any;
    total: number;
}

export const initialState: State = adapter.getInitialState({
    loading: false,
    error: null,
    total: 0
});
